<template>
  <div class="previewBackgroundsComponent">
      <app-previewbackground v-for="background in label.backgrounds" :label="label" :background="background"></app-previewbackground>
  </div>
</template>
<script>
    import PreviewBackground from './Previewbackground';

    export default {
        props      : ['label'],
        components : {
            appPreviewbackground : PreviewBackground
        }

    }
</script>
<style>
    .previewBackgroundsComponent {
        width    : 100%;
        height   : 100%;
        position : absolute;
        top      : 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Preview/PreviewBackgrounds.vue